// @flow

import { observer } from "mobx-react";
import React from "react";

import FeedbackStore from "app/stores/FeedbackStore";
import StatsStore from "app/stores/StatsStore";
import VideoStore from "app/stores/VideoStore";
import VideoShareStore from "app/stores/VideoShareStore";

import ShareBox from "app/components/ShareBox/ShareBox";

type Props = {};

@observer
export default class VideoShareContainer extends React.Component<Props> {
    getUrl(): string {
        const video = VideoStore.video;
        let url =
            window.location.origin +
            "/watch?tlv=" +
            video.uid;
        if (VideoShareStore.time) url += "&st=" + VideoShareStore.time;

        return url;
    }

    render() {
        if (!VideoShareStore.sharing) return null;

        return (
            <ShareBox
                url={this.getUrl()}
                onShare={StatsStore.shareVideoHow}
                onClose={VideoShareStore.close}
                onFeedback={FeedbackStore.create}
                thumbnail={VideoStore.video.timeline_thumbnail}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoShareContainer.js